import { render, staticRenderFns } from "./userLevelStayByCreateRoleTime.vue?vue&type=template&id=4b7b2f4c&"
import script from "./userLevelStayByCreateRoleTime.vue?vue&type=script&lang=js&"
export * from "./userLevelStayByCreateRoleTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7b2f4c')) {
      api.createRecord('4b7b2f4c', component.options)
    } else {
      api.reload('4b7b2f4c', component.options)
    }
    module.hot.accept("./userLevelStayByCreateRoleTime.vue?vue&type=template&id=4b7b2f4c&", function () {
      api.rerender('4b7b2f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/userLevelStayByCreateRoleTime.vue"
export default component.exports